export const dateFormat = 'MMM dd, yyyy';
export const dateFormatMoment = 'MMM DD, YYYY';
export const dateFormatMomentMask = '___ __, ____';
export const dateTimeFormat = 'MMM dd, yyyy HH:mm';
export const dateTimeFormatMoment = 'MMM DD, YYYY HH:mm';
export const dateTimeSecFormatMoment = 'MMM DD, YYYY HH:mm:ss';

export const localDateFormat = 'YYYY-MM-DD';
export const localTimeFormat = 'HH:mm:ss';

export const FILE_DF = 'YYYYMMDD.HHmmss';

export const isoDateFormat = 'YYYY-MM-DD';

export const gridDateSettings = {type: 'date', format: dateFormat};

export const PeriodFormat = 'DD MMM';
